/*
 * @Description: 描述...
 * @Author: LiuYongChun
 * @Date: 2020-11-20 09:44:00
 * @LastEditors: LiuYongChun
 * @LastEditTime: 2020-12-23 14:53:28
 */
import uEditor from './ueditor.vue';

export default {
  install(instance: any) {
    instance.component('uEditor', uEditor);
  },
};
